/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-drug-brand-names.reducer';

export const PharmacyDrugBrandNamesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyDrugBrandNamesEntity = useAppSelector(state => state.pharmacyDrugBrandNames.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyDrugBrandNamesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.detail.title">PharmacyDrugBrandNames</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.id}</dd>
          <dt>
            <span id="brandName">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.brandName">Brand Name</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.brandName}</dd>
          <dt>
            <span id="genericName">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.genericName">Generic Name</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.genericName}</dd>
          <dt>
            <span id="drugType">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.drugType">Drug Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.drugType}</dd>
          <dt>
            <span id="drugUnit">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.drugUnit">Drug Unit</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.drugUnit}</dd>
          <dt>
            <span id="unitPrice">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.unitPrice">Unit Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.unitPrice}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyDrugBrandNames.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyDrugBrandNamesEntity.pharmacy ? pharmacyDrugBrandNamesEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-drug-brand-names" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-drug-brand-names/${pharmacyDrugBrandNamesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyDrugBrandNamesDetail;
